import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-dialog',
  templateUrl: './maintenance-dialog.component.html',
  styleUrls: ['./maintenance-dialog.component.scss']
})
export class MaintenanceDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
